import React from 'react';
import GlobalStyle from './globalStyles';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';

//Pages
import Home from './pages/Home';
import SignUp from './pages/SignupPage';
import Pricing from './pages/PricingPage';
import Applications from './pages/ApplicationsPage';
import Documentation from './pages/Documentation';
// scrum team health
import Commencer from './pages/DocumentationTeamHealth/Commencer'
import ContactAssitance from './pages/DocumentationTeamHealth/ContactAssitance'
import ContratLiscence from './pages/DocumentationTeamHealth/ContratLiscence'
import DeclarationSecurite from './pages/DocumentationTeamHealth/DeclarationSecurite'
import VelocityGadget from './pages/DocumentationTeamHealth/VelocityGadget'
import DemoVideo from './pages/DocumentationTeamHealth/DemoVideo'
// gitlab app
import GettingStartedGit from './pages/DocumentationGitlabMonotoring/GettingStarted'
import SupportGit from './pages/DocumentationGitlabMonotoring/Support'
import DataSecurityGit from './pages/DocumentationGitlabMonotoring/DataSecurity'
import EndUserLicenseGit from './pages/DocumentationGitlabMonotoring/EndUserLicense'
import DemoVideoGit from './pages/DocumentationGitlabMonotoring/DemoVideo'
// app monitoring
import GettingStartedAppMonitoring from './pages/DocumentationAppMonotoring/GettingStarted'
import SupportAppMonitoring from './pages/DocumentationAppMonotoring/Support'
import DataSecurityAppMonitoring from './pages/DocumentationAppMonotoring/DataSecurity'
import EndUserLicenseAppMonitoring from './pages/DocumentationAppMonotoring/EndUserLicense'
import DemoVideoMonitoring from './pages/DocumentationAppMonotoring/DemoVideo'
// app issue date
import GettingStartedAppIssueDate from './pages/DocumentationIssueDate/GettingStarted'
import SupportIssueTab from './pages/DocumentationIssueDate/Support'
import DataSecurity from './pages/DocumentationIssueDate/DataSecurity'
import EndUserLiscenceIssueTab from './pages/DocumentationIssueDate/EndUserLicense'

import Company from './pages/Company/Company'
import Contact from './pages/Contact/Contact'



import Footer from './components/Footer/Footer';

function App() {
	return (
		<Router>
			<GlobalStyle />
			<Navbar />

			<Switch>
				<Route path="/" exact component={Home} />
				<Route path="/signup" exact component={SignUp} />
				<Route path="/pricing" exact component={Pricing} />
				<Route path="/applications" exact component={Applications} />
				<Route path="/documentation-scrum-team" exact component={Documentation} />

				{/* sidemenu for scrum team health  */}
				<Route path="/gettingStartedScrumTeam" exact component={Commencer} />
				<Route path="/supportContactsScrumTeam" exact component={ContactAssitance} />
				<Route path="/contratLicense" exact component={ContratLiscence} />
				<Route path="/Data Security" exact component={DeclarationSecurite} />
				<Route path="/velocityGadget" exact component={VelocityGadget} />
				<Route path="/demonstrationVideo" exact component={DemoVideo} />

				{/* sidemenu for GitlabMonotoring  */}
				<Route path="/gettingStartedGitlabMonotoring" exact component={GettingStartedGit} />
				<Route path="/supportContactsGitlabMonotoring" exact component={SupportGit} />
				<Route path="/DataSecurityGitlabMonotoring" exact component={DataSecurityGit} />
				<Route path="/EndUserLicenseGitlabMonotoring" exact component={EndUserLicenseGit} />
				<Route path="/demonstrationVideoGit" exact component={DemoVideoGit} />

				{/* sidemenu for Application Monotoring  */}
				<Route path="/gettingStartedAppMonotoring" exact component={GettingStartedAppMonitoring} />
				<Route path="/SupportAppMonitoring" exact component={SupportAppMonitoring} />
				<Route path="/DataSecurityAppMonitoring" exact component={DataSecurityAppMonitoring} />
				<Route path="/EndUserLicenseAppMonitoring" exact component={EndUserLicenseAppMonitoring} />
				<Route path="/demonstrationVideoMonitorung" exact component={DemoVideoMonitoring} />

				{/* sidemenu for Application Issue Date   */}
				<Route path="/gettingStartedAppIssueDates" exact component={GettingStartedAppIssueDate} />
				<Route path="/SupportAppIssueDates" exact component={SupportIssueTab} />
				<Route path="/DataSecurityAppIssueDates" exact component={DataSecurity} />
				<Route path="/EndUserLicenseAppIssueDates" exact component={EndUserLiscenceIssueTab} />
				

				{/* company */}
				<Route path="/company" exact component={Company} />
				{/*contact */}
				<Route path="/contact" exact component={Contact} />

			

			</Switch>

			
		</Router>
	);
}

export default App;
